import React from 'react';
import PropTypes from 'prop-types';

const LOADER_VARIANT = {
  BULLET: 'bullet',
};

/**
 * Loader displayed during the loading of some resources.
 */
const Loader = (props) => {
  switch (props.variant) {
    case LOADER_VARIANT.BULLET:
      return (
        <div className={`extra-loader flex justify-center items-center h-2.5 mt-4 mb-8 ${props.isLoading ? 'block' : 'hidden'}`}>
          <div className="first ball h-2.5 w-2.5 rounded-full mx-2.5 bg-green"></div>
          <div className="second ball h-2.5 w-2.5 rounded-full mx-2.5 bg-cmblack"></div>
          <div className="third ball h-2.5 w-2.5 rounded-full mx-2.5 bg-green"></div>
        </div>
      );
  }
};

Loader.propTypes = {
  variant: PropTypes.oneOf(Object.values(LOADER_VARIANT)),
  isLoading: PropTypes.bool,
};

Loader.defaultProps = {
  variant: LOADER_VARIANT.BULLET,
  isLoading: false,
};

export { Loader, LOADER_VARIANT };
